import { useState } from 'react';
import { forgeAssistant } from '../services/groqService';

export default function AIAssistant() {
  const [prompt, setPrompt] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const handleAsk = async () => {
    if (!prompt.trim()) return;
    
    setLoading(true);
    try {
      const result = await forgeAssistant(prompt);
      // console.log(result)
      setResponse(result);
    } catch (err) {
      setResponse("Sorry, AI is currently unavailable.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-zinc-900 rounded-2xl">
      {/* <h2 className="text-xl font-bold mb-4">🔥 AetherForge AI Assistant</h2> */}
      
      <textarea
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        className="w-full p-4 bg-zinc-800 rounded-xl"
        placeholder="Ask anything... (code help, architecture, debugging)"
        rows={4}
      />

      <button
        onClick={handleAsk}
        disabled={loading}
        className="mt-4 cursor-pointer bg-violet-600 hover:bg-violet-500 px-6 py-3 rounded-xl font-semibold"
      >
        {loading ? "Thinking..." : "Ask AI"}
      </button>

      {response && (
        <div className="mt-6 p-4 bg-zinc-800 rounded-xl whitespace-pre-wrap">
          {response}
        </div>
      )}
    </div>
  );
}